import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import CKEditor from "react-ckeditor-component";
import ReactHtmlParser from "react-html-parser";

class WizardFormFirstPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      campaignName: (this.props.dataValue) ? this.props.dataValue.campaignName : '',
      subject: (this.props.dataValue) ? this.props.dataValue.subject : '',
      customEmailContent: (this.props.dataValue) ? this.props.dataValue.customEmailContent : '',
      french_subject: (this.props.dataValue) ? this.props.dataValue.french_subject : '',
      french_customEmailContent: (this.props.dataValue) ? this.props.dataValue.french_customEmailContent : '',
      title:  this.props.dataValue.title,
      campaignNameError: '',
      subjectError: '',
      customEmailContentError: '',
      preview: false,
      multi_lang:"no",
      campaignCityID: (this.props.dataValue) ? this.props.dataValue.campaignCityID : '',
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.mailContent = this.mailContent.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
  }
  

  mailContent = (e) => {
    this.setState({
        customEmailContent: e.editor.getData()
    });
    this.setState({customEmailContentError:""})
  }

  handlePrev = (e) => {
    e.preventDefault();
    this.props.previousPage();
    this.props.onPrevData(this.state)
  }

  handleChange = (e) => {
    if(`this.state.${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    this.setState({[e.target.name] : e.target.value})
  }

  validate = (e) => {
    let isError = false;
    
    if(!this.state.campaignName){
      isError = true;
      this.setState({campaignNameError:"red"})
    }else{
      this.setState({campaignNameError:""})
    }

    if(!this.state.subject){
      isError = true;
      this.setState({subjectError:"red"})
    }

    if(!this.state.customEmailContent){
      isError = true;
      this.setState({customEmailContentError:"red"})
    }else{
      this.setState({customEmailContentError:""})
    }

    if(!this.state.french_subject && this.state.enable_secondstreet=='0' && this.state.multi_lang=="yes"){
      isError = true;
      this.setState({french_subjectError:"red"})
    }

    if(!this.state.french_customEmailContent && this.state.enable_secondstreet=='0' && this.state.multi_lang=="yes"){
      isError = true;
      this.setState({french_customEmailContentError:"red"})
    }else{
      this.setState({french_customEmailContentError:""})
    }

    if(!this.state.campaignCityID){
      isError = true;
      this.setState({campaignCityIDError:"red"})
    }else{
      this.setState({campaignCityIDError:""})
    }
 
    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
      this.props.onSubmit();
      this.props.onSubmitData(this.state);
    }
  }

  componentWillMount(){
    if (this.props.campaignName){
      
    }
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus')); 
    if(siteData){ 
      this.setState({
        enable_secondstreet: siteData.enable_secondstreet,
        enable_postup: siteData.postup,
        multi_lang: siteData.multi_lang, 
      }); 
    }
  }

  handlePreview = (e) => {
    this.setState({preview:true});
  }

  closePreview = (e) => {
    this.setState({preview:false});
  }
  render() {
  return (
    <div>
      <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">{this.state.title}</header>
          <div className="panel-body">
            <Row>
              <Col md={3} xs={12}>
                <FormGroup controlId="cityFilter">
                  <ControlLabel>Select Campaign City</ControlLabel>
                  <FormControl componentClass="select" onChange={this.handleChange} name="campaignCityID" style={{borderColor:this.state.campaignCityIDError}} value={this.state.campaignCityID}>
                    <option value="">Select City</option>
                    {this.props.citiesList.map((data, index) => 
                      <option key={index} value={data.cityID}>{data.title}</option>
                    )}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Name the Campaign:</ControlLabel>
                  <FormControl
                    type="text"
                    placeholder="Campaign Name"
                    defaultValue={this.state.campaignName}
                    name="campaignName"
                    onChange={this.handleChange}
                    style={{borderColor:this.state.campaignNameError}}
                  />
                </FormGroup>
              </Col>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Subject Line:</ControlLabel>
                  <FormControl
                    type="text"
                    placeholder="Subject Line"
                    name="subject"
                    defaultValue={this.state.subject}
                    onChange={this.handleChange}
                    style={{borderColor:this.state.subjectError}}
                  /> 
                </FormGroup>
              </Col>
              {(this.state.enable_secondstreet=='0' && this.state.multi_lang=="yes") && 
                <Col md={12} xs={12}>
                  <FormGroup>
                    <ControlLabel>Subject Line (Canadian French):</ControlLabel>
                    <FormControl
                      type="text"
                      placeholder="Subject Line"
                      name="french_subject"
                      defaultValue={this.state.french_subject}
                      onChange={this.handleChange}
                      style={{borderColor:this.state.french_subjectError}}
                    /> 
                  </FormGroup>
                </Col>
              }
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Email Design: <span className="text-danger">{(this.state.customEmailContentError == 'red') ? '(Email Design is required.)': ''}</span></ControlLabel>                   
                    {/*<CKEditor 
                      activeClass="p10" 
                      content={this.state.customEmailContent} 
                      events={{
                        "change": this.mailContent
                      }}
                     />*/}

                    <FormControl
                      value={
                        this.state.customEmailContent
                      }
                      componentClass="textarea"
                      onChange={this.handleChange}
                      name="customEmailContent"
                      rows={10}
                    />
                </FormGroup>
              </Col>
              {(this.state.enable_secondstreet=='0' && this.state.multi_lang=="yes") && 
                <Col md={12} xs={12}>
                  <FormGroup>
                    <ControlLabel>Email Design (Canadian French): <span className="text-danger">{(this.state.french_customEmailContentError == 'red') ? '(Email Design is required.)': ''}</span></ControlLabel>                   
                    {/*<CKEditor 
                      activeClass="p10" 
                      content={this.state.customEmailContent} 
                      events={{
                        "change": this.mailContent
                      }}
                     />*/}

                    <FormControl
                      value={
                        this.state.french_customEmailContent
                      }
                      componentClass="textarea"
                      onChange={this.handleChange}
                      name="french_customEmailContent"
                      rows={10}
                    />
                  </FormGroup>
                </Col>
              }
            </Row>
            <Row>
              <Col md={12} xs={12}>
              {(this.state.title == 'Multi Offer Email') &&
              <Button bsStyle="success" onClick={this.handlePrev}>Previous</Button>
              }
              <Button type="submit" bsStyle="success" className="pull-right">Save & Continue</Button>
              <a className="btn btn-success pull-right" onClick={this.handlePreview}>Preview</a>
              </Col>
            </Row>
          </div>
        </div>
        {/*<div>
                <button type="submit" className="next">
                  Next
                </button>
              </div>*/}

      </form>
      <Modal show={this.state.preview}  bsSize="large" onHide={this.closePreview}>
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(this.state.customEmailContent) ? ReactHtmlParser(this.state.customEmailContent) : ''}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.closePreview}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )

  }
}

export default WizardFormFirstPage


// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/common/WizardFormFirstPage.js